export enum ParameterType {
  Json,
  FormUrlEncoded,
}
